import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const InvoicesAdvanceService = Services.invoicesAdvance;
const InvoicesAdvanceTypes = VuexTypes.invoicesAdvance;
export default {
  [InvoicesAdvanceTypes.ADV_INVOICES_LIST]: ({ commit, state }, params) => {
    state.advanceInvoicesList['status'] = statuses.LOADING;
    InvoicesAdvanceService.list(params).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICES_LIST, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICES_LIST, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICES_LIST_FILTERS]: ({ commit, state }) => {
    state.advanceInvoicesListFilters['status'] = statuses.LOADING;
    InvoicesAdvanceService.listFilters().then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICES_LIST_FILTERS, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICES_LIST_FILTERS, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_CLASSIFIERS]: ({ commit, state }) => {
    state.advanceInvoiceClassifiers['status'] = statuses.LOADING;
    InvoicesAdvanceService.classifiers().then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_CLASSIFIERS, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_CLASSIFIERS, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_UPDATE_DATA]: ({ commit, state }, userId) => {
    state.advanceInvoiceUpdateData['status'] = statuses.LOADING;
    InvoicesAdvanceService.editData(userId).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_UPDATE_DATA, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_UPDATE_DATA, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_MEDIA_LIST]: ({ commit, state }, invoiceId) => {
    state.advanceInvoiceMediaList['status'] = statuses.LOADING;
    InvoicesAdvanceService.mediaList(invoiceId).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_MEDIA_LIST, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_MEDIA_LIST, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_CREATE]: ({ commit, state }, createData) => {
    state.advanceInvoiceCreate['status'] = statuses.LOADING;
    InvoicesAdvanceService.create(createData).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_CREATE, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_CREATE, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_UPDATE]: ({ commit, state }, { id, update }) => {
    state.advanceInvoiceUpdate['status'] = statuses.LOADING;
    InvoicesAdvanceService.update(id, update).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_UPDATE, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_UPDATE, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_DELETE_ATTACHMENT]: ({ commit, state }, { invoiceId, attachmentId }) => {
    state.advanceInvoiceDeleteAttachment['status'] = statuses.LOADING;
    InvoicesAdvanceService.deleteAttachment(invoiceId, attachmentId).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_DELETE_ATTACHMENT, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_DELETE_ATTACHMENT, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_UPDATE_STATUS]: ({ commit, state }, { invoiceId, updateData }) => {
    state.advanceInvoiceUpdateStatus['status'] = statuses.LOADING;
    InvoicesAdvanceService.updateStatus(invoiceId, updateData).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_UPDATE_STATUS, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_UPDATE_STATUS, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_PAYMENT_APPROVE]: ({ commit, state }, { invoiceId, approvalData }) => {
    state.advanceInvoicePaymentApprove['status'] = statuses.LOADING;
    InvoicesAdvanceService.approvePayment(invoiceId, approvalData).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_PAYMENT_APPROVE, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_PAYMENT_APPROVE, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_PAYMENT_REJECT]: ({ commit, state }, { invoiceId, rejectData }) => {
    state.advanceInvoicePaymentReject['status'] = statuses.LOADING;
    InvoicesAdvanceService.rejectPayment(invoiceId, rejectData).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_PAYMENT_REJECT, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_PAYMENT_REJECT, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_ACTIVITY]: ({ commit, state }, { id, page }) => {
    state.advanceInvoiceActivity['status'] = statuses.LOADING;
    InvoicesAdvanceService.activity(id, page).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_ACTIVITY, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_ACTIVITY, errResponse);
    });
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_DELETE]: ({ commit, state }, advanceInvoiceId) => {
    state.advanceInvoiceDelete['status'] = statuses.LOADING;
    InvoicesAdvanceService.delete(advanceInvoiceId).then((data) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_DELETE, data);
    }).catch((errResponse) => {
      commit(InvoicesAdvanceTypes.ADV_INVOICE_DELETE, errResponse);
    });
  },
};
